export const config = {
	add_button : [4,5,7,8,9,10],
	modify : [2,3,4,5],
	delete : [3,4,5,6,7,8],
	download : [5,8,10,11]
}


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/config/acl.ts